import type {Session} from "@client/contracts";
import {atom} from "nanostores";
import {rpc} from "./rpcs.mjs";

export const SessionAtom = atom<Session | null>(null);

/** null until the first check completes — the UI waits instead of flashing the login form. */
export const ReadyAtom = atom(false);

export async function loadSession(): Promise<void> {
    try {
        const {auth} = await rpc.query({auth: {session: [{}]}});
        SessionAtom.set(auth.session);
    } finally {
        ReadyAtom.set(true);
    }
}

export async function signOut(): Promise<void> {
    await rpc.query({auth: {signOut: [{}]}});
    SessionAtom.set(null);
}
